<template>
  <div class="filelist">
    <drag-modal :visible="$store.state.dislog.FileHistory" @cancel="close" title='保全记录' width='840px'>
      <div class="h2">历史记录</div>
      <div class="table">
        <table cellpadding="0" cellspacing="0">
          <thead>
            <td>资产信息</td>
            <td>保全时间</td>
            <td>保全到期时间</td>
            <td>操作</td>
          </thead>
          <tbody>
            <tr v-for='(i,index) in List' :key='index'>
              <td>
                <Normap :tit='i.content'>{{i.content}}</Normap>
              </td>
              <td>{{i.stime | yearFormat}}</td>
              <td>{{i.etime | yearFormat}}</td>
              <td v-if='clear!=1'>
                <a href='javascript:void(0);' @click='edit(i,true)' v-if='disabled || $common.AccAUTH($store.state.Debinfo.info.accuser.id,"debtor:keep:index")'>查看</a>
                <div style="display:inline-block;" v-if='i.always==0 && !disabled'>
                  <span class="line" v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id,"debtor:keep:edit")'></span>
                  <a href='javascript:void(0);' @click='edit(i)' v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id,"debtor:keep:edit")'>修改</a>
                  <span class="line" v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id,"debtor:keep:always")'></span>
                  <a-popconfirm title="确认续封此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='cold(i.id,index)' v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id,"debtor:keep:always")'>
                    <a href='javascript:void(0);'>续封</a>
                  </a-popconfirm>
                  <span class="line" v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id,"debtor:keep:del")'></span>
                  <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='del(i.id)' v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id,"debtor:keep:del")'>
                    <a href='javascript:void(0);' style="color:#f00;">删除</a>
                  </a-popconfirm>

                </div>
              </td>
              <td v-else>/</td>
            </tr>
          </tbody>
        </table>
        <a-empty v-if='List.length==0' style="margin:20px 0;" />
      </div>
      <div class="bot" v-if="!disabled">
        <a-button type="primary" style="margin-right:20px;width:148px;" @click='addInfo' v-if='clear!=1 && $common.AccAUTH($store.state.Debinfo.info.accuser.id,"debtor:keep:add")'> 新增信息</a-button>
        <a-button style='background:#B2C9E1;color:#fff;width:148px;' @click="close">关闭</a-button>
      </div>
    </drag-modal>
    <drag-modal :visible="visible1" @cancel="()=>visible1=false" :title='title' width='588px' :zIndex='1001'>
      <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{span: 6}" :wrapper-col="{span: 14}">
        <a-form-model-item label="资产信息" prop='content'>
          <a-textarea :rows="4" style="width:600px" v-model='form.content' :disabled='see' />
        </a-form-model-item>
        <a-form-model-item label="保全时间" prop='stime'>
          <a-date-picker v-model='form.stime' @change='(e,s)=>{form.stime=s}' :disabled='see' />
        </a-form-model-item>
        <a-form-model-item label="保全到期时间" prop='etime'>
          <a-date-picker v-model='form.etime' @change='(e,s)=>{form.etime=s}' :disabled='see' />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{span: 24}" prop="files" :rules="{ required: false, message: '请上传附件',trigger: 'change'}">
          <Upload :fList='form.files' @upFileAfter='lisUpload' :Wid='"136px"' :edit='see' :disabled="disabled" />
        </a-form-model-item>
      </a-form-model>
      <div class="bot" v-if='!see'>
        <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='add' v-if='clear!=1'>
          <a-button type="primary" style="margin-right:20px;width:148px;">提交</a-button>
        </a-popconfirm>
        <a-button style='background:#B2C9E1;color:#fff;width:148px;' @click="reset">取消</a-button>
      </div>
    </drag-modal>
  </div>
</template>
<script>
import { debtorKeepAdd, debtorKeepDel, debtorKeepEdit, keepAlways } from "@/server/debtor"
import Upload from "@/components/uploads"
export default {
  name:'FileHistory',
  props: {
    disabled:Boolean,
    List: {
      type: Array,
      default() {
        return []
      }
    },
    clear: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      rules: {
        car_type_id: [{ required: true, trigger: 'blur', message: '请选择债车型' }],
      },
      title: '新增保全记录',
      see: false,
      form: {
        content: null,
        stime: null,
        etime: null,
        files: []
      },
      rules: {
        content: [{ required: true, message: '请输入资产信息', trigger: 'blur' }],
        stime: [{ required: true, trigger: 'change', message: '请选择保全时间', }],
        etime: [{ required: true, trigger: 'change', message: '请选择保全到期时间', }],
      },
      visible: false,
      visible1: false
    }
  },
  components: { Upload },
  methods: {
    lisUpload(fileList) {
      this.form.files = fileList
    },
    cold(id, index) {
      keepAlways({ id: id }).then(e => {
        this.$store.dispatch("Debinfo/getInfo", { id: this.$route.params.id })
        this.$message.success({ content: '续封', key: 'updatable' });
      })
    },
    add() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          if (form.id) {
            form.files = form.files.map(ele => {
              return ele.id || ele
            })
            debtorKeepEdit(form).then(e => {
              this.$message.success({ content: '修改成功', key: 'updatable' });
              this.$store.dispatch("Debinfo/getInfo", { id: this.$route.params.id })
              this.reset()
            })
          } else {
            debtorKeepAdd(Object.assign({ debtor_id: this.$route.params.id }, form)).then(e => {
              this.$message.success({ content: '新增成功', key: 'updatable' });
              this.$store.dispatch("Debinfo/getInfo", { id: this.$route.params.id })
              this.reset()
            })
          }
        }
      })
    },
    addInfo() {
      this.form.stime = null;
      this.form.etime = null;
      this.form.content = null;
      this.form.id = null;
      this.see = false;
      this.title = '新增保全记录'
      this.visible1 = true;

    },
    edit(item, bool) {
      this.form.id = item.id;
      this.form.stime = item.stime;
      this.form.etime = item.etime;
      this.form.content = item.content;
      this.form.files = item.files
      this.visible1 = true;
      this.see = bool
      this.title = bool ? '查看保全记录' : '修改保全记录'
      //    debtorKeepEdit({
      //   "id": 3,
      //   "stime": "2020-12-22",
      //   "etime": "2021-01-08",
      //   "content": "香烟饮料瓜子"

      // })
    },
    del(id) {
      debtorKeepDel({ id: id }).then(e => {
        this.$message.success({ content: '删除成功', key: 'updatable' });
        this.$store.dispatch("Debinfo/getInfo", { id: this.$route.params.id })
      })
    },
    close() {
      this.$store.dispatch('openkey', { key: 'FileHistory', by: false })
    },
    reset() {
      this.$refs.forms.resetFields();
      this.visible1 = false;
    }
  },
}
</script>
<style lang="less" scoped>
.h2 {
  font-size: 16px;
  padding-bottom: 20px;
}
.bot {
  text-align: center;
  padding-top: 30px;
}
.input {
  overflow: hidden;
  display: flex;
  margin-bottom: 24px;
  label {
    width: 100px;
    max-width: 100px;
    line-height: 30px;
  }
}
</style>